import { styled, Box } from "@mui/material";

export const HeaderContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  marginTop: "0.85rem",
}));
